export function getFontSizeInPx(): number {
  const documentStyles = getComputedStyle(document.documentElement)
  return parseFloat(documentStyles.fontSize)
}
